import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import FallbackSpinner from "./@core/component/spinner";

const ComingSoon = React.lazy(() => import("./pages/comingsoon/index"));

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    // <ThemeProvider theme={theme}>
    <div className="App">
      <Suspense fallback={<FallbackSpinner />}>
        <Routes>
          {/* Coming Soon Page - Only accessible route */}
          <Route path="/coming-soon" element={<ComingSoon />} />

          {/* Redirect all other routes to coming soon */}
          <Route path="*" element={<Navigate to="/coming-soon" replace />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
